





















import { defineComponent, ref } from '@nuxtjs/composition-api';
// @ts-ignore
import VClamp from 'vue-clamp';
import AppLink from '~/components/partials/App/AppLink.vue';

export default defineComponent({
  components: {
    VClamp,
    AppLink,
  },
  props: {
    mainText: {
      type: String,
      required: true,
    },
    afterClampText: {
      type: String,
      default: '',
    },
    afterClampTextLink: {
      type: String,
      default: null,
    },
    maxLines: {
      type: Number,
      default: 3,
    },
    // afterClampTextとmainTextが同じ文字色・サイズかどうか
    isSameFont: {
      type: Boolean,
      default: false,
    },
    isProductList: {
      type: Boolean,
      default: false,
    },
    isExternalLink: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isClampingText = ref(true);
    const onClamp = () => (isClampingText.value = false);
    return {
      isClampingText,
      onClamp,
    };
  },
});
